import logo_black_img from "../../assets/logos/logo_bondai_167x48.svg";
import download_blue_img from "../../assets/images/download_blue_img.png";
import download_white_img from "../../assets/images/download_white_img.png";
import gauge_blue from "../../assets/images/gauge_blue.svg";
import gauge_white from "../../assets/images/gauge_white.svg";
import trend_blue from "../../assets/images/trend_blue.svg";
import trend_white from "../../assets/images/trend_white.svg";
import Filter from "../../assets/images/Filter.png";
import download_pdf from "../../assets/images/downloadPdf.svg";
import Filter_selected from "../../assets/images/Filter_selected.png";
import Health_analysis_img from "../../assets/images/health_analysis_img.png";
import hidePwd from "../../assets/images/hidePwd.png";
import history_download_btn from "../../assets/images/history_download_btn.png";
import missed_revenue from "../../assets/images/missed_revenue_trial.svg";
import consumer_behavior from "../../assets/images/consumer_behaviour_trial.svg";
import modal_close_btn from "../../assets/images/modal_close_btn.png";
import mp_icon_Auto_Loan from "../../assets/images/auto_loan_icon.svg";
import mp_icon_Secondary_Consumers from "../../assets/images/secondary_consumer_icon.svg";
import mp_icon_Primary_Consumers from "../../assets/images/primary_consumer_icon.svg";
import mp_icon_Business_Loan from "../../assets/images/business-loan-icon.svg";
import mp_icon_Credit_Card from "../../assets/images/credit_card_icon.svg";
import mp_icon_Consumer_Loan from "../../assets/images/consumer_loan_icon.svg";
import mp_icon_Mortgage from "../../assets/images/mortgage_icon.svg";
import mp_icon_Personal_Loan from "../../assets/images/personal_loan_icon.svg";
import mp_icon_Commercial_Loan from "../../assets/images/mp_icon_Commercial_Loan.svg";
import mp_icon_Student_Loan from "../../assets/images/student_loan_icon.svg";
import mp_icon_Icon_default from "../../assets/images/Default_Merchants.svg";
import dashboard_upgrade_lock from "../../assets/images/upgrade_lock.svg";
import Search from "../../assets/images/Search.png";
import showPwd from "../../assets/images/showPwd.png";
import tp_icon_Borrower from "../../assets/images/Borrower.svg";
import tp_icon_Earner from "../../assets/images/Earner.svg";
import tp_icon_Planner from "../../assets/images/Planner.svg";
import tp_icon_Saver from "../../assets/images/Saver.svg";
import tp_icon_Spender from "../../assets/images/Spender.svg";

import tp_icon_at_risk from "../../assets/images/tp_icon_at_risk.svg";
import tp_icon_growth_minded from "../../assets/images/tp_icon_growth_minded.svg";
import tp_icon_highly_leveraged from "../../assets/images/tp_icon_highly_leveraged.svg";
import tp_icon_bank_loyal from "../../assets/images/tp_icon_bank_loyal.svg";
import tp_icon_liquidity_rich from "../../assets/images/tp_icon_liquidity_rich.svg";
import tp_icon_traditional from "../../assets/images/tp_icon_traditional.svg";
import tp_icon_seasonal from "../../assets/images/tp_icon_seasonal.svg";
import tp_icon_earner from "../../assets/images/tp_icon_earner.svg";
import tp_icon_spender from "../../assets/images/tp_icon_spender.svg";
import tp_icon_borrower from "../../assets/images/tp_icon_borrower.svg";
import tp_icon_planner from "../../assets/images/tp_icon_planner.svg";
import tp_icon_saver from "../../assets/images/tp_icon_saver.svg";
import tp_icon_unscored from "../../assets/images/tp_icon_unscored.svg";
import tp_icon_flexible_planner from "../../assets/images/tp_icon_flexible_planner.webp";
import tp_icon_high_debt from "../../assets/images/tp_icon_high_debt.webp";
import tp_icon_at_risk_earner from "../../assets/images/tp_icon_at_risk_earner.webp";
import tp_icon_low_buffer_saver from "../../assets/images/tp_icon_low_buffer_saver.webp";
import tp_icon_cushion_builder from "../../assets/images/tp_icon_cushion_builder.webp";
import tp_icon_strong_saver from "../../assets/images/tp_icon_strong_saver.webp";
import tp_icon_emerging_earner from "../../assets/images/tp_icon_emerging_earner.webp";
import tp_icon_active_borrower from "../../assets/images/tp_icon_active_borrower.webp";
import tp_icon_active_spender from "../../assets/images/tp_icon_active_spender.webp";
import tp_icon_high_spender from "../../assets/images/tp_icon_high_spender.webp";
import tp_icon_low_debt from "../../assets/images/tp_icon_low_debt.webp";
import tp_icon_established_earner from "../../assets/images/tp_icon_established_earner.webp";
import tp_icon_controlled_spender from "../../assets/images/tp_icon_controlled_spender.webp";
import tp_icon_declining_saver from "../../assets/images/tp_icon_declining_saver.webp";
import tp_icon_rising_earner from "../../assets/images/tp_icon_rising_earner.webp";
import tp_icon_at_risk_planner from "../../assets/images/tp_icon_at_risk_planner.webp";
import tp_icon_light_borrower from "../../assets/images/tp_icon_light_borrower.webp";
import tp_icon_disciplined_planner from "../../assets/images/tp_icon_disciplined_planner.webp";
import tp_icon_predictable_planner from "../../assets/images/tp_icon_predictable_planner.webp";
import tp_icon_subscription_heavy from "../../assets/images/tp_icon_subscription_heavy.webp";

import animation_loader from "../../assets/images/animation_loader.gif";
import dashboard_bond_score from "../../assets/images/dashboard_bond_score.svg";
import dashboard_missed_revenue from "../../assets/images/dashboard_missed_revenue.svg";
import downArrow from "../../assets/images/downArrow.png";
import upload from "../../assets/images/notifications/Upload.png";
import uploadNew from "../../assets/images/blue_export_icon.svg";
import trend from "../../assets/images/trend.svg";
import trendHover from "../../assets/images/trendHover.svg";
import infoIcon from "../../assets/images/InfoCircle.svg";
import chevron_down from "../../assets/images/chevron-down.svg";
import backArrowFilter from "../../assets/images/icon_Back_arrow.svg";
import backArrowNew from "../../assets/images/backArrow.svg";
import filterexpandicon from "../../assets/images/filter_expand_icon.png";
import frontArrowNew from "../../assets/images/frontArrow.svg";
import hoverfrontArrowNew from "../../assets/images/hoverFrontArrow.svg";
import hoverBackArrowNew from "../../assets/images/hoverBackArrow.svg";
import hoverUploadIcon from "../../assets/images/hoverUploadIcon.png";
import filter_colapse from "../../assets/images/filter_collapse_icon.png";
import icon_default_bank from "../../assets/images/bank-default-icon.svg";
import icon_detail_TC from "../../assets/images/icon_detail_TC.svg";
import fileupload from "../../assets/images/faq_icon_fileUpload.png";
import financialHealthScore from "../../assets/images/faq_icon_financialHealthScore.png";
import privacyPolicy from "../../assets/images/faq_icon_privacyPolicy.png";
import templateUsage from "../../assets/images/faq_icon_templateUsage.png";
import hubspot from "../../assets/images/faq_icon_hubspot.png";
import savedFilter from "../../assets/images/savedfilter.svg";
import editsvg from "../../assets/images/edit.svg";
import editCollectionsvg from "../../assets/images/icon_filter_edit.svg";
import deletesvg from "../../assets/images/delete.svg";
import deletefilter from "../../assets/images/filterdelete.svg";
import noDataFound from "../../assets/images/noDataFound.svg";
import filterSaveChanges from "../../assets/images/filterSaveChanges.svg";
import listDark from "./icon_list_dark.svg";
import listLight from "./icon_list_white.svg";
import tileDark from "./icon_layout_dark.svg";
import tileLight from "./icon_layout_light.svg";
import largeBlockDark from "./icon_largetile_dark.svg";
import largeBlockLight from "./icon_largeblock_white.svg";
import icons_Total_consumer from "../../assets/images/Icons_Total consumer.svg";
import icons_total_accounts from "../../assets/images/Icons_total accounts.svg";
import icon_total_transactions from "../../assets/images/Icon_total transactions.svg";
import icon_Date_range from "../../assets/images/Icon_Date range.svg";
import FA_icons_arrow_up from "../../assets/images/FA_icons_arrow_up.svg";
import FA_icons_arrow_down from "../../assets/images/FA_icons_arrow_down.svg";
import lock_white from "../../assets/images/lock_white.svg";
import icon_circular_lock from "../../assets/images/icon_circular_lock.svg";
import icon_circular_lock_new from "../../assets/images/campaign_locked_circular.svg";
import locked_statistic_section from "../../assets/images/locked_statistic_section.svg";
import locked_thumbnail_section from "../../assets/images/locked_thumbnail_section.svg";
import locked_table_section from "../../assets/images/locked_table_section.svg";
import icon_role_star from "./Icons_star.svg";
import FU_cross from "./FU_cross.svg";

import uplift_loans from "./uplift_loan.svg";
import automated_marketing from "./automated_marketing.svg";
import beat_the_competition from "./beat_the_competition.svg";
import banking_services from "./banking_services.svg";

import boost_deposits from "./boost_deposits.svg";
import card_expand_btn from "./card_expand_btn.svg";
import scheduled_campaign_img from "./scheduled-campaign.svg";
import active_campaign_img from "./active_campaign.svg";

import FHS_cohortaverage from "./cohortaverage.svg";
import FHS_institution from "./FHS_institution.svg";
import FHS_efficiencyratio from "./efficiencyratio.svg";
import FHS_AdjAllowanceForLoanLossesOvernplsToTotalLoansRatio from "./FHS_AdjAllowanceForLoanLossesOvernplsToTotalLoansRatio.svg";
import FHS_grossnpa from "./grossnpa.svg";
import FHS_Growth_Score from "./growth.svg";
import FHS_Financial_Health_Score from "./bank.svg";

import RS_ReturnOnAverageAssets from "./RS_ReturnOnAverageAssets.svg";
import RS_NPAToTotalLoans from "./RS_NPAToTotalLoansRatio.svg";
import RS_AdjNPAToTotalAssests from "./RS_AdjNPAToTotalAssests.svg";
import GS_CostOfInterbankdeposits from "./GS_CostOfInterbankdeposits.svg";

import FHS_Stability_Score from "./riskscore.svg";
import FHS_cohortaverage_score from "./cohort_avg_score.svg";
import FHS_netintrestmargin from "./netintrestmargin.svg";
import FHS_netnpa from "./netnpa.svg";
import FHS_percentile from "./fhs_percentile.svg";
import FHS_totalassetsyeargrowth from "./totalassetsyeargrowth.svg";
import FHS_totaldepositsyeargrowth from "./totaldepositsyeargrowth.svg";
import FHS_totalloansyeargrowth from "./totalloansyeargrowth.svg";
import FHS_returnonaverageassets from "./returnonaverageassets.svg";
import FHS_NPAToTotalLoansRatio from "./FHS_NetWorthToTotalAssetsRatio.svg";
import FHS_YieldCost from "./FHS_DelinquentLoansToNetWorthRatio.svg";
import GS_CostOfTimeDeposits from "./GS_PercentageChangeInTotalShareDrafts.svg";
import GA_PercentChangeInTotalAssets from "./GS_YieldOnAverageEarningAssets.svg";

//Chatbot icon
import bont_bot_icon_from from "./Bond_Bot_Icon_Front.png";
import bont_bot_icon_back from "./Bond_Bot_Icon_Back.png";

//Email Campaign icons
import icon_reviews_pending from "./time_half_past.svg";
import icon_approved_campaign from "./mail_favourite.svg";
import icon_ongoing_campaign from "./mail_arrow_right.svg";
import icon_drafted_capmaign from "./group_33.svg";
import icon_deleted_campaign from "./trash_white.svg";
import icon_completed_campaign from "./tick_double.svg";

import icon_users from "./users.svg";
import icon_mail_fail from "./mail_fail.svg";
import icon_mail_block from "./mail_block.svg";

import list_icon_eye from "./mail_eye_list.svg";
import list_icon_trash from "./mail_trash_list.svg";
import list_icon_edit_grey from "./mail_edit_icon.svg";
import list_icon_speed_test from "./mail_icon_speed_test.svg";
import list_icon_edit from "./edit_list.svg";
import list_icon_delete from "./list_icon_delete.svg";
import list_icon_delete_white from "./list_icon_delete_white.svg";
import list_icon_edit_solid from "./list_icon_edit_solid.svg";
import list_icon_edit_solid_white from "./list_icon_edit_solid_white.svg";
import no_cohort from "./no_cohort.svg";
import no_cohort_bank from "./no_cohort_bank.svg";
import create_cohort_icon from "./create_cohort_icon.svg";
import edit_cohort_icon from "./edit_cohort_icon.svg";
import delete_cohort_icon from "./delete_cohort_icon.svg";
import cohort_success_icon from "./cohort_success_icon.svg";

import success_popup_icon from "../../assets/images/Success.svg";
import error_icon from "../../assets/images/error_icon.svg";
import success_icon from "../../assets/images/success_icon.svg";
import new_template_icon from "../../assets/images/post_add.svg";

import RT_fail_icon from "../images/RT_fail_icon.svg";
import RT_retry_icon from "../images/RT_retry_icon.svg";
import RT_check_icon from "../images/RT_check_icon.svg";
import RT_contactSupport_icon from "../images/RT_contactSupport_icon.svg";
import RT_login_icon from "../images/RT_login_icon.svg";
import RT_reset_passowrd_icon from "../images/RT_reset_passowrd_icon.svg";
import RI_link_expired_main_icon from "../images/RI_link_expired_main_icon.svg";
import RT_verification_link_icon from "../images/RT_verification_link_icon.svg";
import RT_inbox_icon from "../images/RT_inbox_icon.svg";

import RE_Recipients_icon from "../../assets/images/RE_Recipients_icon.svg";
import RE_TotalConsumer_icon from "../../assets/images/RE_TotalConsumer_icon.svg";
import RE_Subject_icon from "../../assets/images/RE_Subject_icon.svg";
import RE_TemplateName_icon from "../../assets/images/RE_TemplateName_icon.svg";
import RE_SendSchedule_icon from "../../assets/images/RE_SendSchedule_icon.svg";
import RE_Status_icon from "../../assets/images/RE_Status_icon.svg";
import RE_CancelButton_icon from "../../assets/images/RE_CancelButton_icon.svg";
import RE_SMS_content_icon from "../../assets/images/RE_SMS_content_icon.svg";
import RE_SMS_link_icon from "../../assets/images/RE_SMS_link_icon.svg";
import RE_Campaign_type from "../images/RE_Campaign_type.svg";
import RE_Campaign_frequency from "../images/RE_Campaign_frequency.svg";
import RE_Campaign_Event from "../images/RE_Campaign_Event.svg";
import RE_Campaign_Triggered from "../images/RE_Campaign_Triggered.svg";
import merchant_default_icon_upgrade from "../../assets/images/merchant_default_icon.svg";
import growth_upgrade_default from "../../assets/images/growth_upgrade_default.svg";
import missed_revenue_upgrade from "../../assets/images/missed_revenue_upgrade.svg";
import icon_upgrade_campaign from "../../assets/images/icon_upgrade_campaign.svg";
import trend_upgrade from "../../assets/images/trend_upgrade.svg";
import export_upgrade from "../../assets/images/export_upgrade.svg";
import contact_sales_team_upgrade from "../../assets/images/contact_sales_team.svg";
import contact_sales_team_success_upgrade from "../../assets/images/contact_sales_team_success.svg";
import automated_marketing_upgrade from "../../assets/images/automated_marketing_upgrade.svg";
import uplift_loans_upgrade from "../../assets/images/uplift_loans_upgrade.svg";
import beat_the_competition_upgrade from "../../assets/images/beat_the_competition_upgrade.svg";
import boost_deposits_upgrade from "../../assets/images/boost_deposits_upgrade.svg";
import consumer_behavior_upgrade from "../../assets/images/consumer_behaviour_upgrade.svg";
import FHS_red_arrow_down from "../../assets/images/FHS_red_arrow_down.svg";
import FHS_green_arrow_up from "../../assets/images/FHS_green_arrow_up.svg";
import mobile_static_img from "../../assets/images/mobile_static_img.svg";
import toggle_grid_view_blue from "../../assets/images/toggle-grid-view-blue.svg";
import toggle_grid_view_white from "../../assets/images/toggle-grid-view-white.svg";
import toggle_tile_view_blue from "../../assets/images/toggle-tile-view-blue.svg";
import toggle_tile_view_white from "../../assets/images/toggle-tile-view-white.svg";
import summary_view_white from "../../assets/images/summary_view_white.svg";
import summary_view_blue from "../../assets/images/summary_view_blue.svg";
import expanded_view_white from "../../assets/images/expanded_view_white.svg";
import expanded_view_blue from "../../assets/images/expanded_view_blue.svg";
import sample_template_one from "../../assets/images/sample-template-one-new.svg";
import sample_template_two from "../../assets/images/sample-template-two.png";
import sample_template_three from "../../assets/images/sample-template-three.png";

import icon_auto_loan from "../../assets/images/icon_auto_loan.svg";
import icon_credit_card from "../../assets/images/icon_credit_card.svg";
import icon_student_loan from "../../assets/images/icon_student_loan.svg";
import icon_business_loan from "../../assets/images/icon_business_loan.svg";
import icon_commercial_loan from "../../assets/images/icon_commercial_loan.svg";
import icon_mortgage from "../../assets/images/icon_mortgage.svg";
import icon_consumer_loan from "../../assets/images/icon_consumer_loan.svg";
import icon_personal_loan from "../../assets/images/icon_personal_loan.svg";
import icon_general_merchandise from "../../assets/images/general_merchandise.svg";
import icon_restaurant from "../../assets/images/restaurant.svg";
import icon_gaming from "../../assets/images/gaming.svg";
import icon_entertainment from "../../assets/images/entertainment.svg";
import icon_personal_care from "../../assets/images/personal_care.svg";
import icon_service_fee from "../../assets/images/service_fee.svg";
import icon_payment from "../../assets/images/payment.svg";
import icon_groceries from "../../assets/images/groceries.svg";
import icon_electronics from "../../assets/images/electronics.svg";
import icon_other_income from "../../assets/images/other_income.svg";
import icon_clothing from "../../assets/images/clothing.svg";
import icon_digital_wallet from "../../assets/images/digital_wallet.svg";
import icon_travel from "../../assets/images/travel.svg";
import icon_pension_and_insurance from "../../assets/images/pension_and_insurance.svg";
import icon_mobile from "../../assets/images/mobile.svg";
import icon_bill_payment from "../../assets/images/bill_payment.svg";
import icon_withdrawal from "../../assets/images/withdrawal.svg";
import icon_fast_food from "../../assets/images/fast_food.svg";
import icon_online_service from "../../assets/images/online_service.svg";
import icon_healthcare from "../../assets/images/healthcare.svg";
import icon_beverage from "../../assets/images/beverage.svg";
import icon_late_payment from "../../assets/images/late_payment.svg";
import icon_transfer from "../../assets/images/transfer.svg";
import icon_gifts from "../../assets/images/gifts.svg";
import icon_gas_and_fuel from "../../assets/images/gas_and_fuel.svg";
import icon_food_and_drink from "../../assets/images/food_and_drink.svg";
import icon_primary_consumer_with_dda from "../../assets/images/primary_consumer_with_dda.svg";
import icon_primary_consumer_without_dda from "../../assets/images/primary_consumer_without_dda.svg";
import icon_secondary_consumer_with_dda from "../../assets/images/secondary_consumer_with_dda.svg";
import icon_secondary_consumer_without_dda from "../../assets/images/secondary_consumer_without_dda.svg";
import icon_transportation from "../images/transportation.svg";
import icon_medical from "../images/medical.svg";
import icon_home_improvement from "../images/home_improvement.svg";
import icon_general_services from "../images/general_services.svg";
import icon_rent_and_utilities from "../images/rent_and_utilities.svg";
import icon_account_transfer from "../../assets/images/account_transfer.svg";
import icon_account_transfer_coloured from "../../assets/images/account_transfer_coloured.svg";

import icon_investment from "../../assets/images/icon_investment.svg";
import icon_investment_coloured from "../../assets/images/icon_investment_coloured.svg";

import icon_commercial_investment from "../../assets/images/icon_commercial_investment.svg";
import icon_commercial_investment_coloured from "../../assets/images/icon_commercial_investment_coloured.svg";

import icon_general_transfer from "../../assets/images/icon_general_transfer.svg";
import icon_general_transfer_coloured from "../../assets/images/icon_general_transfer_coloured.svg";

import icon_person_to_person from "../../assets/images/icon_person_to_person.svg";
import icon_person_to_person_coloured from "../../assets/images/icon_person_to_person_coloured.svg";

import icon_529_education_accounts from "../../assets/images/529_education_accounts.svg";
import icon_529_education_accounts_coloured from "../../assets/images/529_education_accounts_coloured.svg";
import icon_ira from "../../assets/images/ira_icon.svg";
import icon_ira_coloured from "../../assets/images/ira_icon_coloured.svg";
import icon_certificates_of_deposit from "../../assets/images/certificates_of_deposit.svg";
import icon_certificates_of_deposit_coloured from "../../assets/images/certificates_of_deposit_coloured.svg";
import icon_commercial_loan_payments_others from "../../assets/images/commercial_loan_payments_others.svg";
import icon_commercial_loan_payments_others_coloured from "../../assets/images/commercial_loan_payments_others_coloured.svg";
import icon_checking from "../../assets/images/checking.svg";

import icon_line_of_credit from "../../assets/images/icon_line_of_credit.svg";
import icon_term_loan from "../../assets/images/icon_term_loan.svg";
import icon_trade_finance from "../../assets/images/icon_trade_finance.svg";
import icon_p_card from "../../assets/images/icon_p_card.svg";
import icon_real_estate_loan from "../../assets/images/icon_real_estate_loan.svg";
import icon_corporate_card from "../../assets/images/icon_corporate_card.svg";

import icon_checking_coloured from "../../assets/images/checking_coloured.svg";
import icon_health_savings_account from "../../assets/images/health_savings_account.svg";
import icon_health_savings_account_coloured from "../../assets/images/health_savings_account_coloured.svg";
import icon_savings from "../../assets/images/savings.svg";
import icon_savings_coloured from "../../assets/images/savings_coloured.svg";
import icon_deposit from "../../assets/images/deposit.svg";

import icon_short_term_investment_solutions from "../../assets/images/icon_short_term_investment_solutions.svg";
import icon_short_term_investment_solutions_coloured from "../../assets/images/icon_short_term_investment_solutions_coloured.svg";
import icon_zero_balance_account from "../../assets/images/icon_zero_balance_account.svg";
import icon_zero_balance_account_coloured from "../../assets/images/icon_zero_balance_account_coloured.svg";
import icon_operating_checking_account from "../../assets/images/icon_operating_checking_account.svg";
import icon_operating_checking_account_coloured from "../../assets/images/icon_operating_checking_account_coloured.svg";
import icon_business_savings_account from "../../assets/images/icon_business_savings_account.svg";
import icon_business_savings_account_coloured from "../../assets/images/icon_business_savings_account_coloured.svg";
import icon_remote_deposit_capture from "../../assets/images/icon_remote_deposit_capture.svg";
import icon_remote_deposit_capture_coloured from "../../assets/images/icon_remote_deposit_capture_coloured.svg";
import icon_sweep_account from "../../assets/images/icon_sweeps.svg";
import icon_sweep_account_coloured from "../../assets/images/icon_sweeps_coloured.svg";
import icon_money_market_account from "../../assets/images/icon_money_market_account.svg";
import icon_money_market_account_coloured from "../../assets/images/icon_money_market_account_coloured.svg";
import icon_business_checking_account from "../../assets/images/icon_business_checking_account.svg";
import icon_business_checking_account_coloured from "../../assets/images/icon_business_checking_account_coloured.svg";
import icon_external_bank_transfers from "../../assets/images/icon_external_bank_transfers.svg";
import icon_external_bank_transfers_coloured from "../../assets/images/icon_external_bank_transfers_coloured.svg";

import icon_default_avatar from "../../assets/images/icon_default_avatar.svg";
import icon_merchant_services from "../../assets/images/icon_merchant_services.svg";
import icon_payroll_services from "../../assets/images/icon_payroll_services.svg";
import icon_ach_wire_transfer from "../../assets/images/icon_ach_wire_transfer.svg";
import icon_401k_administrations from "../../assets/images/icon_401k_administrations.svg";

import campaign_pii_status from "../../assets/images/campaign_pii_status.jpg";
import no_image from "../../assets/images/no-image.svg";
import cohort_icon from "../../assets/images/cohort-icon.svg";
import cohortremoveicon from "../../assets/images/cohortremoveicon.svg";
import cohortsorticon from "../../assets/images/cohort-sort.svg";
import cohortediticon from "../../assets/images/cohort_edit.svg";
import cohortdeleteicon from "../../assets/images/cohort_delete.svg";
import cohortNoData from "../../assets/images/cohort_no_data.svg";
import cohortNavigationIcon from "../../assets/images/cohort-navigation-icon.svg";
import cohort_percentile_icon from "../../assets/images/cohort-percentile-icon.svg";
import cohort_avg_icon from "../../assets/images/cohort-avg-icon.svg";
import cohort_institution_count_icon from "../../assets/images/cohort-institution-icon.svg";

import power_button from "../../assets/images/power_button.svg";
import power_button_blue from "../../assets/images/power_button_blue.svg";

import icons_privacy_policy from "../../assets/images/icons_privacy_policy.svg";
import icons_privacy_policy_blue from "../../assets/images/icons_privacy_policy_blue.svg";

import icons_settings from "../../assets/images/icons_settings.svg";
import icons_settings_bule from "../../assets/images/icons_settings_bule.svg";

import total_assets_icon from "./total_assets_icon.svg";
import deposit_growth_icon from "./deposit_growth_icon.svg";
import loan_growth_icon from "./loan_growth_icon.svg";
import efficiency_ratio_icon from "./efficiency_ratio_icon.svg";
import net_interest_income_nii_icon from "./net_interest_income_nii_icon.svg";
import net_interest_margin_nim_icon from "./net_interest_margin_nim_icon.svg";
import gross_npa_icon from "./gross_npa_icon.svg";
import npa_to_total_loans_ratio_icon from "./npa_to_total_loans_ratio_icon.svg";
import cohort_average_icon from "./cohort_average_icon.svg";
import cohort_institution from "./cohort_institution.svg";
import cohort_percentile from "./cohort_percentile.svg";
import cohort_avg from "./cohort_avg.svg";
import asset_ratio from "./asset_ratio.svg";
import net_operating_income from "./net_operating_income.svg";
import return_on_equity from "./return_on_equity.svg";
import tier_1_capital_ratio from "../images/tier_1_capital_ratio.svg";
import tier_1_leverage_ratio from "../images/tier_1_leverage_ratio.svg";
import non_performing_asssets_to_total_assets from "../images/non_performing_asssets_to_total_assets.svg";
import loan_loss_reserve_to_total_loans_and_leases from "../images/loan_loss_reserve_to_total_loans_and_leases.svg";
import classified_assets_ratio from "../images/classified_assets_ratio.svg";
import net_liquidity_ratio from "../images/net_liquidity_ratio.svg";
import loan_to_deposit_ratio from "../images/loan_to_deposit_ratio.svg";
import liquidity_coverage_ratio from "../images/liquidity_coverage_ratio.svg";
import bulb_fhs_detail from "../../assets/images/bulb_fhs_detail.svg";
import dollaricon from "../../assets/images/dollaricon.svg";
import arrowside from "../../assets/images/arrow_side.svg";
import down_arrow_white from "../../assets/images/down_arrow_white.svg";
import emailCancel from "../../assets/images/email-cancel.svg";
import thumbsUp from "../../assets/images/thumbsup.svg";
import thumbsDown from "../../assets/images/thumbsdown.svg";
import downloadIcon from "../../assets/images/downloadicon.svg";
import insights_icon_1 from "../../assets/images/insights_icon_1.svg";
import insights_icon_2 from "../../assets/images/insights_icon_2.svg";
import insights_lock_icon from "../../assets/images/insights_lock_icon.svg";
import insights_icon_shortterm from "../../assets/images/insights_icon_shortterm.svg";
import insights_icon_midterm from "../../assets/images/insights_icon_midterm.svg";
import insights_icon_longterm from "../../assets/images/insights_icon_longterm.svg";
import insights_icon_recommendation from "../../assets/images/insights_icon_recommendation.svg";
import insights_icon_recommendation_new from "../../assets/images/insights_icon_recommendation_new.svg";
import insights_icon_problem from "../../assets/images/insights_icon_problem.svg";
import insights_icon_rational from "../../assets/images/insights_icon_rational.svg";
import insights_icon_weak_load from "../../assets/images/insights_icon_weak_load.svg";
import insights_icon_nplms from "../../assets/images/insights_icon_nplms.svg";
import insights_popup_bgimg from "../../assets/images/insights_popup_bgimg.svg";
import payment_successful_bgimg from "../../assets/images/payment_successful_bgimg.svg";
import pdf_logo from "../images/pdf/FHS_details/Icon.png";
import pdf_page_banner from "../images/pdf/FHS_details/people-talking-group-meeting-work 1 (2).png";
import EWI_not_found from "../images/EWI_not_found.svg";
import EWI_problem_pdf_icon from "../images/pdf/FHS_details/EWI_Problem_pdf_icon.png";
import EWI_Rationale_pdf_icon from "../images/pdf/FHS_details/EWI_Rationale_pdf_icon.png";
import EWI_Reccomendation_pdf_icon from "../images/pdf/FHS_details/EWI_Reccomendation_pdf_icon.png";
import EWI_Short_trem_pdf_icon from "../images/pdf/FHS_details/EWI_Short_trem_pdf_icon.png";
import EWI_Mid_trem_pdf_icon from "../images/pdf/FHS_details/EWI_Mid_trem_pdf_icon.png";
import EWI_Long_trem_pdf_icon from "../images/pdf/FHS_details/EWI_Long_trem_pdf_icon.png";
import EWI_icon_1 from "../images/EWI_icon_1.png";
import EWI_icon_2 from "../images/EWI_icon_2.png";
import EWI_icon_3 from "../images/EWI_icon_3.png";
import EWI_icon_4 from "../images/EWI_icon_4.png";
import EWI_icon_5 from "../images/EWI_icon_5.png";
import EWI_icon_6 from "../images/EWI_icon_6.png";
import EWI_icon_7 from "../images/EWI_icon_7.png";
import EWI_icon_8 from "../images/EWI_icon_8.png";
import EWI_icon_9 from "../images/EWI_icon_9.png";
import EWI_icon_10 from "../images/EWI_icon_10.png";
import EWI_icon_11 from "../images/EWI_icon_11.png";
import EWI_icon_12 from "../images/EWI_icon_12.png";
import EWI_icon_13 from "../images/EWI_icon_13.png";
import EWI_icon_14 from "../images/EWI_icon_14.png";
import EWI_icon_15 from "../images/EWI_icon_15.png";
import EWI_lock_icon from "../images/EWI_lock_icon.png";
import EWI_under_maintenance from "../images/EWI_under_maintenance.svg";
import EWI_subscription_icon from "../images/EWI_Subscription_icon.png";
import EWI_arrow_right from "../images/EWI_arrow_right.png";
import EWI_upgrade_icon from "../images/EWI_upgrade_icon.svg";
import EWI_chatbot_tool_consultation from "../images/EWI_chatbot_tool_consultation.svg";
import EWI_chatbot_tool_new_chat from "../images/EWI_chatbot_tool_new_chat.svg";
import EWI_chatbot_tool_history from "../images/EWI_chatbot_tool_history.svg";
import EWI_selected_chatbot_tool_history from "../images/EWI_selected_chatbot_tool_history.svg";
import EWI_chatbot_tool_bookmark from "../images/EWI_chatbot_tool_bookmark.svg";
import EWI_selected_chatbot_tool_bookmark from "../images/EWI_selected_chatbot_tool_bookmark.svg";
import EWI_chatbot_tool_close from "../images/EWI_chatbot_tool_close.svg";
import EWI_chatbot_tool_deleted_chat from "../images/EWI_chatbot_tool_deleted_chat.svg";
import EWI_selected_chatbot_tool_deleted_chat from "../images/EWI_selected_chatbot_tool_deleted_chat.svg";
import EWI_chatbot_tool_chatbot_logo from "../images/EWI_chatbot_tool_chatbot_logo.svg";
import EWI_chatbot_tool_hover_logo from "../images/EWI_chatbot_tool_hover_logo.svg";
import EWI_chatbot_tool_up_arrow from "../images/EWI_chatbot_tool_up_arrow.svg";
import EWI_chatbot_tool_icon_cross from "../images/EWI_chatbot_tool_icon_cross.svg";
import EWI_chatbot_tool_share_hover from "../images/EWI_chatbot_tool_share_hover.svg";
import EWI_chatbot_tool_bookmark_hover from "../images/EWI_chatbot_tool_bookmark_hover.svg";
import EWI_chatbot_tool_delete_hover from "../images/EWI_chatbot_tool_delete_hover.svg";
import EWI_chatbot_tool_no_history_list from "../images/EWI_chatbot_tool_no_history_list.svg";
import EWI_chatbot_tool_delete_chat_restore from "../images/EWI_chatbot_tool_delete_chat_restore.svg";
import EWI_chatbot_tool_delete_chat_fix from "../images/EWI_chatbot_tool_delete_chat_fix.svg";
import EWI_chatbot_tool_no_deleted_chat_list from "../images/EWI_chatbot_tool_no_deleted_chat_list.svg";
import EWI_chatbot_tool_bookmark_selected from "../images/EWI_chatbot_tool_bookmark_selected.svg";
import Chatbot_menu from "../images/Chatbot_menu.svg";
import EWI_chatbot_tool_consultation_white from "../images/EWI_chatbot_tool_consultation_white.svg";
import EWI_chatbot_tool_empty_big from "../images/EWI_chatbot_tool_empty_big.svg";
import EWI_chatbot_tool_rename from "../images/EWI_chatbot_tool_rename.svg";
import EWI_chatbot_tool_save_threadname from "../images/EWI_chatbot_tool_save_threadname.svg";
import EWI_chatbot_tool_discard_threadname from "../images/EWI_chatbot_tool_discard_threadname.svg";

import PDF_EWI_icon_1 from "../images/pdf/FHS_details/EWI_icon_1.png";
import PDF_EWI_icon_2 from "../images/pdf/FHS_details/EWI_icon_2.png";
import PDF_EWI_icon_3 from "../images/pdf/FHS_details/EWI_icon_3.png";
import PDF_EWI_icon_4 from "../images/pdf/FHS_details/EWI_icon_4.png";
import PDF_EWI_icon_5 from "../images/pdf/FHS_details/EWI_icon_5.png";
import PDF_EWI_icon_6 from "../images/pdf/FHS_details/EWI_icon_6.png";
import PDF_EWI_icon_7 from "../images/pdf/FHS_details/EWI_icon_7.png";
import PDF_EWI_icon_8 from "../images/pdf/FHS_details/EWI_icon_8.png";
import PDF_EWI_icon_9 from "../images/pdf/FHS_details/EWI_icon_9.png";
import PDF_EWI_icon_10 from "../images/pdf/FHS_details/EWI_icon_10.png";
import PDF_EWI_icon_11 from "../images/pdf/FHS_details/EWI_icon_11.png";
import PDF_EWI_icon_12 from "../images/pdf/FHS_details/EWI_icon_12.png";
import user_resend_invite from "../images/User_Resend_Invite.svg";
import TM_popup_btn from "../images/TM_popup_icon.svg";
import white_download_icon from "../images/white-download-icon.svg";
import campaign_performance from "../images/campaign_performance.svg";
import campaign_performance_hover from "../images/campaign_performance_hover.svg";
import campaign_recipients from "../images/campaign_recipients.svg";
import campaign_recipients_hover from "../images/campaign_recipients_hover.svg";
import icon_primary_consumer from "../images/icon-primary-consumer.svg";
import icon_accounts_per_consumer from "../images/icon-account-per-consumer.svg";
import icon_opportunities_per_consumer from "../images/icon-opportunities-per-consumer.svg";
import icon_new_analysis_notification from "../images/new_analysis_notification_icon.svg";

import notification_right_arrow from "../images/notification_right_arrow.svg";
import icon_new_analysis_complete from "../images/notification_data_analysis_complete.svg";
import icon_notification_badge from "../images/notification_badge.svg";
import icon_analysis_failed from "../images/icon_analysis_failed.svg";
import icon_notification_default from "../images/icon_notification_default.svg";

import green_upward_arrow from "../images/pdf/FHS_details/green_upward_arrow.png";
import green_downward_arrow from "../images/pdf/FHS_details/green_downward_arrow.png";
import orange_upward_arrow from "../images/pdf/FHS_details/orange_upward_arrow.png";
import orange_downward_arrow from "../images/pdf/FHS_details/orange_downward_arrow.png";
import red_upward_arrow from "../images/pdf/FHS_details/red_upward_arrow.png";
import red_downward_arrow from "../images/pdf/FHS_details/red_downward_arrow.png";
import chatbot_Close_icon from "../images/Chatbot_Close_iocn.svg";
import chatbot_main_icon from "../images/chatbot_main_icon.svg";
import chatbot_send_icon from "../images/Chatbot_send_iocn.svg";
import chatbot_user_msg_icon from "../images/Chatbot_user_msg_iocn.svg";
import chatbot_question_icon from "../images/Chatbot_question_icon.svg";

import chatbot_icon from "../images/chatbot_icon.svg";

import active_user_inbox from "../images/active_user_inbox.svg";
import active_user_secure_link from "../images/active_user_secure_link.svg";
import active_user_expire_link from "../images/active_user_expire_link.svg";
import active_not_received_email from "../images/active_not_received_email.svg";
import active_verification_account from "../images/active_verification_account.svg";
import beta_version_info_icon from "../images/beta_version_info_icon.svg";

import icons_subscription from "../images/icons_subscription.svg";
import icons_subscription_blue from "../images/icons_subscription_blue.svg";
import icon_subscription_status from "../images/icon_subscription_status.svg";
import icon_subscription_next_billing_date from "../images/icon_subscription_next_billing_date.svg";
import icon_subscription_payment_method from "../images/icon_subscription_payment_method.svg";
import icon_subscription_view from "../images/icon_subscription_view.svg";
import icon_disabled_view from "../images/icon_disabled_view.svg";
import icon_subscription_download from "../images/icon_subscription_download.svg";
import icon_disabled_downloadFile from "../images/icon_disabled_downloadFile.svg";
import icon_add_payment_method from "../images/icon_add_payment_method.svg";
import icon_default_payment_method from "../images/icon_default_payment_method.svg";
import icon_PM_visa from "../images/icon_PM_visa.svg";
import icon_PM_mastercard from "../images/icon_PM_mastercard.svg";
import icon_remove_payment_method from "../images/icon_remove_payment_method.svg";

import pricing_template_bg from "../images/pricing_template_bg.svg";
import pricing_check_icon from "../images/pricing_check_icon.svg";
import consultant from "../images/consultant.svg";
import allan from "../images/allan.svg";
import leftLeaf from "../images/leftLeaf.svg";
import rightLeaf from "../images/rightLeaf.svg";
import consultantBackground from "../images/consultantBackground.svg";
import howitworks from "../images/howitworks.svg";
import discoveryoval from "../images/discoveryoval.svg";
import discoveryGroup from "../images/discoveryGroup.svg";
import analysisIcon from "../images/analysisIcon.svg";
import strategyIcon from "../images/strategyIcon.svg";
import executionIcon from "../images/executionIcon.svg";
import sln_Img1 from "../images/slnImg1.svg";
import sln_Img2 from "../images/slnImg2.svg";
import sln_background from "../images/sln_background.svg";
import rightLogo from "../images/rightLogo.svg";
import confirmation from "../images/confirmation.svg";
import confirmationIcon from "../images/confirmationIcon.svg";
import payment_successful_icon from "../images/payment_successful_icon.svg";

import mid_ring from "../images/mid_ring.svg";
import cnfIcon1 from "../images/cnfIcon1.svg";
import cnfIcon2 from "../images/cnfIcon2.svg";
import cnfIcon3 from "../images/cnfIcon3.svg";

import likeIcon from "../images/likeIcon.svg";
import dislikeIcon from "../images/dislikeIcon.svg";
import copyIcon from "../images/copyIcon.svg";
import likeIconFill from "../images/likeIconFill.svg";
import dislikeIconFill from "../images/dislikeIconFill.svg";

import header_aria_logo from "../images/header_aria_logo.png";
import header_aria_label from "../images/header_aria_label.png";

import insights_exist_popup_img from "../images/insights_exist_popup_img.png";
import no_data_primary_checking_account from "../images/no_data_primary_checking_account.svg";
import detail_arrow from "../images/detail_arrow.svg";

const hoverUploadIconNew = uploadNew;
const icon_default = FHS_Financial_Health_Score;
const cohort_average = FHS_cohortaverage;
const icon_primary_consumers = icon_primary_consumer_with_dda;
const icon_secondary_consumers = icon_secondary_consumer_with_dda;
const EWI_Default_img = EWI_icon_6;

const exportimages = {
  dislikeIconFill,
  likeIconFill,
  likeIcon,
  dislikeIcon,
  copyIcon,
  mid_ring,
  confirmationIcon,
  payment_successful_icon,
  cnfIcon1,
  cnfIcon2,
  cnfIcon3,
  confirmation,
  rightLogo,
  sln_background,
  sln_Img1,
  sln_Img2,
  analysisIcon,
  strategyIcon,
  executionIcon,
  discoveryGroup,
  discoveryoval,
  howitworks,
  consultantBackground,
  bulb_fhs_detail,
  consumer_behavior,
  mp_icon_Primary_Consumers,
  mp_icon_Secondary_Consumers,
  error_icon,
  success_icon,
  RT_fail_icon,
  RT_retry_icon,
  RT_check_icon,
  RT_contactSupport_icon,
  RT_login_icon,
  RT_reset_passowrd_icon,
  RI_link_expired_main_icon,
  RT_verification_link_icon,
  RT_inbox_icon,
  campaign_pii_status,
  sample_template_one,
  sample_template_two,
  sample_template_three,
  toggle_tile_view_white,
  toggle_tile_view_blue,
  toggle_grid_view_white,
  toggle_grid_view_blue,
  icon_role_star,
  listDark,
  listLight,
  tileDark,
  tileLight,
  largeBlockDark,
  largeBlockLight,
  logo_black_img,
  noDataFound,
  filterSaveChanges,
  deletefilter,
  editsvg,
  editCollectionsvg,
  deletesvg,
  savedFilter,
  hubspot,
  templateUsage,
  privacyPolicy,
  financialHealthScore,
  fileupload,
  chevron_down,
  icon_default_bank,
  icon_detail_TC,
  hoverfrontArrowNew,
  backArrowNew,
  backArrowFilter,
  filterexpandicon,
  filter_colapse,
  frontArrowNew,
  hoverBackArrowNew,
  hoverUploadIcon,
  download_blue_img,
  download_white_img,
  Filter,
  Filter_selected,
  Health_analysis_img,
  hidePwd,
  history_download_btn,
  missed_revenue,
  modal_close_btn,
  mp_icon_Auto_Loan,
  mp_icon_Business_Loan,
  mp_icon_Commercial_Loan,
  mp_icon_Credit_Card,
  mp_icon_Consumer_Loan,
  mp_icon_Mortgage,
  mp_icon_Personal_Loan,
  mp_icon_Student_Loan,
  mp_icon_Icon_default,
  Search,
  showPwd,
  trend_blue,
  trend_white,
  gauge_white,
  gauge_blue,
  tp_icon_Borrower,
  tp_icon_Earner,
  tp_icon_Planner,
  tp_icon_Saver,
  tp_icon_Spender,
  tp_icon_at_risk,
  tp_icon_growth_minded,
  tp_icon_highly_leveraged,
  tp_icon_bank_loyal,
  tp_icon_liquidity_rich,
  tp_icon_traditional,
  tp_icon_seasonal,
  tp_icon_earner,
  tp_icon_spender,
  tp_icon_borrower,
  tp_icon_planner,
  tp_icon_saver,
  tp_icon_unscored,
  tp_icon_flexible_planner,
  tp_icon_high_debt,
  tp_icon_at_risk_earner,
  tp_icon_low_buffer_saver,
  tp_icon_cushion_builder,
  tp_icon_strong_saver,
  tp_icon_emerging_earner,
  tp_icon_active_borrower,
  tp_icon_active_spender,
  tp_icon_high_spender,
  tp_icon_low_debt,
  tp_icon_established_earner,
  tp_icon_controlled_spender,
  tp_icon_declining_saver,
  tp_icon_rising_earner,
  tp_icon_at_risk_planner,
  tp_icon_light_borrower,
  tp_icon_disciplined_planner,
  tp_icon_predictable_planner,
  tp_icon_subscription_heavy,
  animation_loader,
  download_pdf,
  dashboard_bond_score,
  dashboard_missed_revenue,
  downArrow,
  down_arrow_white,
  trend,
  trendHover,
  upload,
  infoIcon,
  uploadNew,
  hoverUploadIconNew,
  icons_Total_consumer,
  icons_total_accounts,
  icon_total_transactions,
  icon_Date_range,
  FA_icons_arrow_up,
  FA_icons_arrow_down,
  lock_white,
  icon_circular_lock,
  icon_circular_lock_new,
  locked_statistic_section,
  locked_thumbnail_section,
  locked_table_section,
  FU_cross,
  FHS_Financial_Health_Score,
  FHS_cohortaverage,
  FHS_institution,
  FHS_cohortaverage_score,
  FHS_efficiencyratio,
  FHS_AdjAllowanceForLoanLossesOvernplsToTotalLoansRatio,
  RS_ReturnOnAverageAssets,
  RS_NPAToTotalLoans,
  RS_AdjNPAToTotalAssests,
  GS_CostOfInterbankdeposits,
  FHS_grossnpa,
  FHS_Growth_Score,
  FHS_netintrestmargin,
  FHS_netnpa,
  FHS_percentile,
  FHS_returnonaverageassets,
  FHS_NPAToTotalLoansRatio,
  FHS_YieldCost,
  GS_CostOfTimeDeposits,
  GA_PercentChangeInTotalAssets,
  FHS_Stability_Score,
  FHS_totalassetsyeargrowth,
  FHS_totaldepositsyeargrowth,
  FHS_totalloansyeargrowth,
  bont_bot_icon_from,
  bont_bot_icon_back,
  icon_reviews_pending,
  icon_approved_campaign,
  icon_ongoing_campaign,
  icon_drafted_capmaign,
  icon_deleted_campaign,
  icon_completed_campaign,
  list_icon_eye,
  list_icon_trash,
  list_icon_edit,
  list_icon_speed_test,
  list_icon_edit_grey,
  list_icon_delete,
  list_icon_delete_white,
  list_icon_edit_solid,
  list_icon_edit_solid_white,
  no_cohort,
  no_cohort_bank,
  create_cohort_icon,
  edit_cohort_icon,
  delete_cohort_icon,
  cohort_success_icon,
  icon_users,
  icon_mail_fail,
  icon_mail_block,
  success_popup_icon,
  new_template_icon,
  RE_Recipients_icon,
  RE_TotalConsumer_icon,
  RE_Subject_icon,
  RE_TemplateName_icon,
  RE_SendSchedule_icon,
  RE_Status_icon,
  RE_CancelButton_icon,
  RE_SMS_content_icon,
  RE_SMS_link_icon,
  RE_Campaign_type,
  RE_Campaign_frequency,
  RE_Campaign_Event,
  RE_Campaign_Triggered,
  dashboard_upgrade_lock,
  merchant_default_icon_upgrade,
  growth_upgrade_default,
  missed_revenue_upgrade,
  automated_marketing_upgrade,
  uplift_loans_upgrade,
  consumer_behavior_upgrade,
  beat_the_competition_upgrade,
  card_expand_btn,
  scheduled_campaign_img,
  active_campaign_img,
  icon_upgrade_campaign,
  trend_upgrade,
  export_upgrade,
  contact_sales_team_upgrade,
  contact_sales_team_success_upgrade,
  uplift_loans,
  automated_marketing,
  beat_the_competition,
  banking_services,
  boost_deposits,
  boost_deposits_upgrade,
  FHS_red_arrow_down,
  FHS_green_arrow_up,
  mobile_static_img,
  summary_view_white,
  summary_view_blue,
  expanded_view_white,
  expanded_view_blue,
  icon_default,
  icon_auto_loan,
  icon_personal_loan,
  icon_credit_card,
  icon_student_loan,
  icon_mortgage,
  icon_business_loan,
  icon_commercial_loan,
  icon_consumer_loan,
  icon_primary_consumers,
  icon_secondary_consumers,
  icon_general_merchandise,
  icon_restaurant,
  icon_gaming,
  icon_entertainment,
  icon_personal_care,
  icon_service_fee,
  icon_payment,
  icon_groceries,
  icon_electronics,
  icon_other_income,
  icon_clothing,
  icon_digital_wallet,
  icon_travel,
  icon_pension_and_insurance,
  icon_mobile,
  icon_bill_payment,
  icon_withdrawal,
  icon_fast_food,
  icon_online_service,
  icon_healthcare,
  icon_beverage,
  icon_late_payment,
  icon_transfer,
  icon_gifts,
  icon_gas_and_fuel,
  icon_food_and_drink,
  icon_primary_consumer_with_dda,
  icon_primary_consumer_without_dda,
  icon_secondary_consumer_with_dda,
  icon_secondary_consumer_without_dda,
  icon_transportation,
  icon_medical,
  icon_home_improvement,
  icon_general_services,
  icon_rent_and_utilities,
  no_image,
  cohort_icon,
  cohort_average,
  cohortremoveicon,
  cohortsorticon,
  cohortediticon,
  cohortdeleteicon,
  cohortNoData,
  cohortNavigationIcon,
  cohort_percentile_icon,
  cohort_avg_icon,
  cohort_institution_count_icon,
  power_button,
  power_button_blue,
  icons_privacy_policy,
  icons_privacy_policy_blue,
  icons_settings,
  icons_settings_bule,
  total_assets_icon,
  deposit_growth_icon,
  loan_growth_icon,
  efficiency_ratio_icon,
  net_interest_income_nii_icon,
  net_interest_margin_nim_icon,
  gross_npa_icon,
  npa_to_total_loans_ratio_icon,
  cohort_average_icon,
  cohort_percentile,
  cohort_avg,
  cohort_institution,
  asset_ratio,
  net_operating_income,
  return_on_equity,
  tier_1_capital_ratio,
  tier_1_leverage_ratio,
  non_performing_asssets_to_total_assets,
  loan_loss_reserve_to_total_loans_and_leases,
  classified_assets_ratio,
  net_liquidity_ratio,
  loan_to_deposit_ratio,
  liquidity_coverage_ratio,
  dollaricon,
  arrowside,
  emailCancel,
  thumbsUp,
  thumbsDown,
  downloadIcon,
  insights_icon_1,
  insights_icon_2,
  insights_lock_icon,
  insights_icon_shortterm,
  insights_icon_midterm,
  insights_icon_longterm,
  insights_icon_recommendation,
  insights_icon_recommendation_new,
  insights_icon_problem,
  insights_icon_rational,
  insights_icon_weak_load,
  insights_icon_nplms,
  insights_popup_bgimg,
  payment_successful_bgimg,
  icon_account_transfer,
  icon_account_transfer_coloured,
  icon_investment,
  icon_investment_coloured,
  icon_commercial_investment,
  icon_commercial_investment_coloured,
  icon_general_transfer,
  icon_general_transfer_coloured,
  icon_person_to_person,
  icon_person_to_person_coloured,
  icon_savings,
  icon_savings_coloured,
  icon_529_education_accounts,
  icon_529_education_accounts_coloured,
  icon_ira,
  icon_ira_coloured,
  icon_certificates_of_deposit,
  icon_certificates_of_deposit_coloured,
  icon_commercial_loan_payments_others,
  icon_commercial_loan_payments_others_coloured,
  icon_checking,
  icon_line_of_credit,
  icon_term_loan,
  icon_trade_finance,
  icon_p_card,
  icon_real_estate_loan,
  icon_corporate_card,
  icon_checking_coloured,
  icon_health_savings_account,
  icon_health_savings_account_coloured,
  icon_deposit,
  icon_short_term_investment_solutions,
  icon_short_term_investment_solutions_coloured,
  icon_zero_balance_account,
  icon_zero_balance_account_coloured,
  icon_operating_checking_account,
  icon_operating_checking_account_coloured,
  icon_business_savings_account,
  icon_business_savings_account_coloured,
  icon_remote_deposit_capture,
  icon_remote_deposit_capture_coloured,
  icon_sweep_account,
  icon_sweep_account_coloured,
  icon_money_market_account,
  icon_money_market_account_coloured,
  icon_business_checking_account,
  icon_business_checking_account_coloured,
  icon_external_bank_transfers,
  icon_external_bank_transfers_coloured,
  icon_default_avatar,
  icon_merchant_services,
  icon_payroll_services,
  icon_ach_wire_transfer,
  icon_401k_administrations,
  pdf_logo,
  pdf_page_banner,
  EWI_not_found,
  EWI_problem_pdf_icon,
  EWI_Reccomendation_pdf_icon,
  EWI_Rationale_pdf_icon,
  EWI_Short_trem_pdf_icon,
  EWI_Mid_trem_pdf_icon,
  EWI_Long_trem_pdf_icon,
  EWI_Default_img,
  EWI_icon_1,
  EWI_icon_2,
  EWI_icon_3,
  EWI_icon_4,
  EWI_icon_5,
  EWI_icon_6,
  EWI_icon_7,
  EWI_icon_8,
  EWI_icon_9,
  EWI_icon_10,
  EWI_icon_11,
  EWI_icon_12,
  EWI_icon_13,
  EWI_icon_14,
  EWI_icon_15,
  EWI_lock_icon,
  EWI_under_maintenance,
  EWI_subscription_icon,
  EWI_arrow_right,
  EWI_chatbot_tool_consultation,
  EWI_chatbot_tool_new_chat,
  EWI_chatbot_tool_history,
  EWI_selected_chatbot_tool_history,
  EWI_chatbot_tool_bookmark,
  EWI_selected_chatbot_tool_bookmark,
  EWI_chatbot_tool_close,
  EWI_chatbot_tool_deleted_chat,
  EWI_selected_chatbot_tool_deleted_chat,
  EWI_chatbot_tool_chatbot_logo,
  EWI_chatbot_tool_hover_logo,
  EWI_chatbot_tool_up_arrow,
  EWI_chatbot_tool_icon_cross,
  EWI_chatbot_tool_share_hover,
  EWI_chatbot_tool_bookmark_hover,
  EWI_chatbot_tool_delete_hover,
  EWI_chatbot_tool_no_history_list,
  EWI_chatbot_tool_delete_chat_restore,
  EWI_chatbot_tool_delete_chat_fix,
  EWI_chatbot_tool_no_deleted_chat_list,
  EWI_chatbot_tool_bookmark_selected,
  Chatbot_menu,
  EWI_chatbot_tool_consultation_white,
  EWI_chatbot_tool_empty_big,
  EWI_chatbot_tool_rename,
  EWI_chatbot_tool_save_threadname,
  EWI_chatbot_tool_discard_threadname,
  PDF_EWI_icon_1,
  PDF_EWI_icon_2,
  PDF_EWI_icon_3,
  PDF_EWI_icon_4,
  PDF_EWI_icon_5,
  PDF_EWI_icon_6,
  PDF_EWI_icon_7,
  PDF_EWI_icon_8,
  PDF_EWI_icon_9,
  PDF_EWI_icon_10,
  PDF_EWI_icon_11,
  PDF_EWI_icon_12,
  user_resend_invite,
  TM_popup_btn,
  white_download_icon,
  campaign_performance,
  campaign_performance_hover,
  campaign_recipients,
  campaign_recipients_hover,
  icon_primary_consumer,
  icon_accounts_per_consumer,
  icon_opportunities_per_consumer,
  icon_new_analysis_notification,
  notification_right_arrow,
  icon_new_analysis_complete,
  icon_notification_badge,
  icon_analysis_failed,
  icon_notification_default,
  green_upward_arrow,
  green_downward_arrow,
  orange_upward_arrow,
  orange_downward_arrow,
  red_upward_arrow,
  red_downward_arrow,
  chatbot_Close_icon,
  chatbot_main_icon,
  chatbot_send_icon,
  chatbot_user_msg_icon,
  EWI_upgrade_icon,
  chatbot_question_icon,
  chatbot_icon,
  active_user_inbox,
  active_user_secure_link,
  active_user_expire_link,
  active_not_received_email,
  active_verification_account,
  beta_version_info_icon,
  icons_subscription,
  icons_subscription_blue,
  icon_subscription_status,
  icon_subscription_next_billing_date,
  icon_subscription_payment_method,
  icon_subscription_view,
  icon_disabled_view,
  icon_subscription_download,
  icon_disabled_downloadFile,
  icon_add_payment_method,
  icon_default_payment_method,
  icon_PM_visa,
  icon_PM_mastercard,
  icon_remove_payment_method,
  pricing_template_bg,
  pricing_check_icon,
  header_aria_logo,
  header_aria_label,
  insights_exist_popup_img,
  consultant,
  allan,
  leftLeaf,
  rightLeaf,
  no_data_primary_checking_account,
  detail_arrow,
};
export default exportimages;
